export const REQUEST_URL_PAGAMENTO = 'REQUEST_URL_PAGAMENTO'
export const RECEIVE_URL_PAGAMENTO = 'RECEIVE_URL_PAGAMENTO'
export const REQUEST_EXECUTE_PAGAMENTO = 'REQUEST_EXECUTE_PAGAMENTO'
export const RECEIVE_EXECUTE_PAGAMENTO = 'RECEIVE_EXECUTE_PAGAMENTO'
export const REQUEST_SAVE_PAYPAL_REMEMBER_CARD = 'REQUEST_EXECUTE_PAGAMENTO'
export const RECEIVE_SAVE_PAYPAL_REMEMBER_CARD = 'RECEIVE_EXECUTE_PAGAMENTO'
export const REQUEST_SAVE_COMPROVANTE_PAGAMENTO = 'REQUEST_SAVE_COMPROVANTE_PAGAMENTO'
export const RECEIVE_SAVE_COMPROVANTE_PAGAMENTO = 'RECEIVE_SAVE_COMPROVANTE_PAGAMENTO'
export const REQUEST_PAGARME_PIX_TRANSACTION = 'REQUEST_PAGARME_PIX_TRANSACTION'
export const RECEIVE_PAGARME_PIX_TRANSACTION = 'RECEIVE_PAGARME_PIX_TRANSACTION'
export const REQUEST_PAGARME_CAPTURE_TRANSACTION = 'REQUEST_PAGARME_CAPTURE_TRANSACTION'
export const RECEIVE_PAGARME_CAPTURE_TRANSACTION = 'RECEIVE_PAGARME_CAPTURE_TRANSACTION'
